import { IANAZone } from 'luxon';

import { System } from "../models/firebase.model";
import { ProductModelService } from "../models";
import { MyCertifiedPlant, PlantMonitoringEnumType } from "../telemetry";
import { ChangePathSegment } from "./aws.systems.model";

export const formatSegment = (changePath: string): ChangePathSegment[] => {
  /**
   *  Remove the first segment, which is the root
   */
  const [_, ...segments] = changePath.split(/(?!\B'[^']*)\.(?![^']*'\B)/);

  return segments.map((segment) => {
    /**
     * We have conditions only when we have a list
     * condition is needed to find the right element in the list
     */
    const match = segment.match(/(.+?)='(.+?)'/);
    if (match) {
      return {
        type: 'attributeList',
        key: match[1],
        value: match[2],
      };
    }
    return {
      type: 'attribute',
      key: segment,
    };
  });
}

export const fromAwsSystemListToSystemList = (awsSystems: Partial<MyCertifiedPlant>[]) => {
  return awsSystems
    .filter((awsSystem) => awsSystem.plantId && awsSystem.plantPref)
    .map((awsSystem) => {
    if (!awsSystem.plantId || !awsSystem.plantPref) {
      throw new Error('Plant ID or Plant Pref not found');
    }

    const system: System = {
      source: 'aws',
      loggersType: awsSystem.config?.monitoringType ?? (awsSystem.plantPref.monitorPref as unknown as PlantMonitoringEnumType),
      aws: awsSystem,
      monitorPref: awsSystem.plantPref.monitorPref,
      uid: awsSystem.plantId,
      name: awsSystem.plantPref.plantName ?? awsSystem.plantId,
      devices: awsSystem.plantPref.tagsDevices?.map(({ key, value }) => ({
        id: key,
        name: value,
        type: (() => {
          const product = new ProductModelService(key);
          const productType = product.type?.name;
          if (!productType) {
            throw new Error('Product type not found');
          }
          return productType;
        })()
      })) ?? [],
      configuration: (() => {
        const ianaCode = awsSystem.geo?.IANA || 'Europe/Rome';
        const zone = IANAZone.create(ianaCode);

        const offsetOnMins = zone.offset(new Date().getTime());
        const offsetOnQuarter = Math.round(offsetOnMins / 15);

        const coordinates = `${awsSystem.geo?.latitude},${awsSystem.geo?.longitude}`;
        return {
          temporaryZoneList: [],
          activeZone: {
            tz: offsetOnQuarter,
            coordinates,
          },
          /**
           * This is a fake value, with IANA code we don't need this
           */
          timezoneEnd: 0,
        };
      })(),
      img: '',
    };

    const connext = system.devices?.find((device) => device.type === 'connext');
    const azzurroHub = system.devices?.find((device) => device.type === 'azzurro-hub');

    if (connext) {
      system.configuration = {
        ...system.configuration,
        connextId: connext.id?.toLowerCase(),
      };
    }

    if (azzurroHub) {
      system.configuration = {
        ...system.configuration,
        azzurroHubId: azzurroHub.id?.toUpperCase(),
      };
    }

    return system;
  });
}
